/*
 * The campaign types offered by the Campaigns search filter (GAP-1429). The filter shows them
 * through formatCampaignType (Targeted_Events) and sends these raw values. SPONSORED is
 * deliberately absent: production has no global sponsored campaigns.
 */
export default {
    TARGETED_EVENTS: 'TARGETED_EVENTS',
    TARGETED_RESTRICTED: 'TARGETED_RESTRICTED',
    TARGETED_SPONSORED: 'TARGETED_SPONSORED',
};
